// extracted by mini-css-extract-plugin
module.exports = {"buttons":"V2xph7O7Z_e0gJpFp5xL7"};